interface Props {
  title: string;
  subtitle: string;
}

const Heading = ({ title, subtitle }: Props) => (
  <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-4">
    <div className="text-center">
      <h2
        className="h2 font-extrabold leading-tighter tracking-tighter mb-4"
        data-aos="zoom-y-out"
      >
        {title}
      </h2>
      <div className="mx-w-3xl mx-auto">
        <p
          className="text-xl text-gray-600 mb-8"
          data-aos="zoom-y-out"
          data-aos-delay="150"
        >
          {subtitle}
        </p>
      </div>
    </div>
  </div>
);

export default Heading;
